/**
 * @generated SignedSource<<2f3c1b5c5c13e0f2c8ac07a7b3af9c7a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarSellerInfo_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly canShowSellerName: boolean | null;
  readonly " $fragmentType": "PdpRespSidebarSellerInfo_user";
};
export type PdpRespSidebarSellerInfo_user$key = {
  readonly " $data"?: PdpRespSidebarSellerInfo_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarSellerInfo_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarSellerInfo_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canShowSellerName",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "34b127cf56092b378bfe25ab635f1fdf";

export default node;
